import { render } from "./MobileTransits.vue?vue&type=template&id=3edc574a&scoped=true"
import script from "./MobileTransits.vue?vue&type=script&lang=js"
export * from "./MobileTransits.vue?vue&type=script&lang=js"

import "./MobileTransits.vue?vue&type=style&index=0&id=3edc574a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3edc574a"]])

export default __exports__